import React from 'react';
import PropTypes from 'prop-types';

import { Label, Popup } from 'semantic-ui-react';
import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const GRADES = {
  A: 'Top 20% of audiences',
  B: '60-80% of audiences',
  C: '40-60% of audiences',
  D: '20-40% of audiences',
  E: 'Bottom 20% of audiences',
  U: 'Audience could not be graded'
}

const AudienceCredibility = props => {
  const { profile } = props;

  const {audienceCredibility} = profile;

  if(!audienceCredibility) {
    return (
      <div style={padding20}>
        <h2 style={leftAlign}>N/A</h2>
        <BlockLabel label="Audience Credibility" />
      </div>
    );
  }

  const {credibilityGrade} = audienceCredibility;
  const audienceText = GRADES[credibilityGrade];

  return (
    <div style={padding20}>
      <div style={{textAlign: 'left'}}>

        <Popup
          trigger={
          <Label circular color="pink" size="massive" basic>
            {audienceCredibility.credibilityGrade}
          </Label>
          }
          content={`Grade ${credibilityGrade} audience. ${audienceText}`}
        />
      </div>
      <BlockLabel label="Audience Credibility" />
    </div>
  );
};

AudienceCredibility.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default AudienceCredibility;



// WEBPACK FOOTER //
// ./src/containers/summary/components/audience-credibility.js